import { doRequest } from '@r1-frontend/do-request/index';
import { IPacketDto } from '@r1-frontend/api-domru/api-epg/v1/dto/IPacketDto';
import { getPackageChannels } from '@r1-frontend/api-domru/api-epg/v1/packets';
import getTvPackets, { RequestDto, ResponseDto } from '@r1-frontend/api-domru/api-profile/v2/tv-packets/index';

import { formatterEpg } from '~/src/helpers/channel/channelFormatterForEpg';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import { ETvPackagesActionTypes } from '~/src/store/reducers/tvPackages';


export const fetchProfileTvPackages = (params?: RequestDto) => {
    return async(dispatch: TAppThunkDispatch): Promise<void> => {

        // есть дублирующие вызовы, например, на /lk/domru-tv/packages/channels
        dispatch({
            type: ETvPackagesActionTypes.GET_PACKAGES,
            payload: {
                fetching: true,
            },
        });

        const resp = await doRequest.apiProfile<ResponseDto>(getTvPackets({ ...params }));

        if (resp.isSuccess) {
            const {
                connectedInTariff = [],
                connectedOutTariff = [],
                canConnect = [],
                terminalId,
            } = formatterEpg(resp.payload);

            dispatch({
                type: ETvPackagesActionTypes.SET_PACKAGES,
                payload: {
                    fetching: false,
                    connectedInTariff,
                    connectedOutTariff,
                    canConnect,
                    terminalId,
                },
            });
        } else {
            dispatch({
                type: ETvPackagesActionTypes.ERROR_PACKAGES,
                payload: {
                    fetching: false,
                    fetchError: resp.error.message,
                },
            });
        }
    };
};

interface IEpgRequestParams {
    packetIds?: number[],
    notNullPrice?: 0 | 1,
    active?: 0 | 1,
    with?: string,
}

export const fetchEpgTvPackages = (params?: IEpgRequestParams) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const { city: { provider: { providerId } } } = getState();

        dispatch({
            type: ETvPackagesActionTypes.GET_PACKAGES,
            payload: {
                fetching: true,
            },
        });

        const resp = await doRequest.apiEPG<IPacketDto[]>(
            getPackageChannels(providerId, { ...params, active: params?.active !== 0 ? 1 : 0 }),
        );

        if (resp.isSuccess) {
            dispatch({
                type: ETvPackagesActionTypes.SET_PACKAGES,
                payload: {
                    fetching: false,
                    fetchError: null,
                    allPackages: resp.payload,
                },
            });
        } else {
            dispatch({
                type: ETvPackagesActionTypes.ERROR_PACKAGES,
                payload: {
                    fetching: false,
                    // @ts-ignore
                    fetchError: resp.error.message,
                },
            });
        }
    };
};

export const fetchTvPackages = () => {
    return (dispatch: TAppThunkDispatch, getState: TGetState) => {
        const { auth: { isAuth } } = getState();

        isAuth
            ? dispatch(fetchProfileTvPackages())
            : dispatch(fetchEpgTvPackages({ notNullPrice: 1, active: 1, with: 'channels,themes' }));
    };
};
